export default __webpack_public_path__ + "static/media/placeholder_dummy2016-delikatessen01-mobile.d2e7cb8c.png";